const initGTM = tenantApp => {
  console.log('==== Init google tag manager ====');
  const email = tenantApp?.externalInfo?.email || tenantApp?.optEmail || '';
  window.dataLayer = window.dataLayer || [];

  console.log('=== window.dataLayer: ', window.dataLayer);
  window.dataLayer.push({
    event: 'identify',
    traits: {
      user_id: email,
      email: email,
      shopify: { shop_id: tenantApp.tenantId }
    },
    properties: {
      app: 'boost',
      platform: 'shopify'
    }
  });
};

export { initGTM };
